import { createFileRoute } from "@tanstack/react-router";
import { MaaledataPerioderPage } from "@/features/maaledata/MaaledataPerioderPage";

export const Route = createFileRoute("/_app/_subheader/maalerdata/")({
  component: MaaledataPerioderPage,
  head: () => ({
    meta: [
      {
        title: "Målerdata | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
